var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G Mark 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Blue 500",
    d: "M19.7504 10.2451C19.7504 9.51294 19.6845 8.81236 19.562 8.13867H10.0854V11.9983L15.5432 11.9995C15.3218 13.2837 14.6094 14.3784 13.5179 15.1083V17.6123H16.7666C18.6636 15.8685 19.7504 13.2907 19.7504 10.2451Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Green 500 1",
    d: "M13.519 15.109C12.6147 15.7149 11.4501 16.0693 10.0877 16.0693C7.45602 16.0693 5.22347 14.3079 4.42394 11.9336H1.07275V14.5161C2.73304 17.7886 6.14545 20.0342 10.0877 20.0342C12.8125 20.0342 15.1016 19.1441 16.7677 17.612L13.519 15.109Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow 500 1",
    d: "M4.10832 10.018C4.10832 9.3513 4.22018 8.70686 4.42389 8.10101V5.51855H1.07271C0.386221 6.87177 0 8.39925 0 10.018C0 11.6367 0.387398 13.1642 1.07271 14.5174L4.42389 11.9349C4.22018 11.3291 4.10832 10.6846 4.10832 10.018Z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Red 500",
    d: "M10.0877 3.96491C11.5749 3.96491 12.9067 4.47368 13.9582 5.46783L16.8372 2.61052C15.0886 0.992982 12.809 0 10.0877 0C6.14663 0 2.73304 2.24561 1.07275 5.51812L4.42394 8.10058C5.22347 5.72631 7.45602 3.96491 10.0877 3.96491Z",
    fill: "#E94235"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.62da3483aeb90dc13731539033522294.svg";
export { ForwardRef as ReactComponent };